// extracted by mini-css-extract-plugin
module.exports = {"info":"ContactInfo_info__aVL9V","info_content":"ContactInfo_info_content__pTT21"};